import React from "react";

const SkeletonCard = () => {
  return (
    <div className="w-full max-w-sm rounded-2xl p-6 shadow-md bg-gradient-to-b from-gray-100 to-gray-200 animate-pulse">
      {/* Title */}
      <div className="h-4 w-full bg-gray-300 rounded mb-2"></div>
      <div className="h-3 w-full bg-gray-300 rounded mb-4"></div>

      {/* Data */}
      <div className="h-3 w-full bg-gray-300 rounded mb-2"></div>
      <div className="h-5 w-full bg-gray-300 rounded mb-6"></div>

      {/* Button */}
      <div className="h-10 w-full bg-gray-300 rounded-full"></div>
    </div>
  );
};

const ShimmerSkeleton = () => {
  return (
    <div className="grid grid-cols-1  gap-6 p-6">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
};

export default ShimmerSkeleton;
